import Title from '@/components/InspectionReport/Items/Questions/Title';

export default {
    functional: true,
    props: {
        item: {
            type: Object,
            required: true,
        },
        resource: {
            type: Object,
            default: null,
        },
    },
    render(h, { props, data }) {
        const childElements = [h(Title, {}, props.item.title)];
        if (props.item.params.image) {
            childElements.push(h('img', { attrs: { src: props.item.params.image } }));
        }
        return h('div', data, childElements);
    },
};
